// PremiumPlanType аналог enum на Swift
export const PremiumPlanType = {
    free: "free",
    premiumScout: "premium_scout",
    premiumFullstackHR: "premium_fullstack_hr"
  };
  
  // Модель PremiumPlan
  export class PremiumPlan {
    constructor(type, title, label, price, description, features) {
      this.type = type;
      this.title = title;
      this.label = label;
      this.price = price;
      this.description = description;
      this.features = features;
    }
  }
  
  // 🔥 Фабрика всех планов
  export default class PremiumPlansFactory {
    static allPlans() {
      return [
        new PremiumPlan(
          PremiumPlanType.free,
          "Соискатель",
          "Бесплатно",
          "Сейчас у вас",
          "Оптимально для соискателя",
          [
            "Доступен весь Ai функционал",
            "Безлимит на создание диалогов",
            "Ранний доступ к вакансиям через пуши"
          ]
        ),
  
        new PremiumPlan(
          PremiumPlanType.premiumScout,
          "Скаут+",
          "ПРЕМИУМ",
          "3 990 ₽ / месяц",
          "Для стартапов и команд",
          [
            "Неограниченно кол-во вакансий",
            "Неограниченно кол-во ивентов",
            "Неограниченный Ai-smartmatching",
            "Доступен весь Ai функционал",
            "Безлимит на создание диалогов"
          ]
        ),
  
        new PremiumPlan(
          PremiumPlanType.premiumFullstackHR,
          "Фуллстак HR",
          "ПРЕМИУМ",
          "7 990 ₽ / месяц",
          "Для агентств и частных соискателей",
          [
            "Публикация вакансий от разных компаний",
            "Неограниченно кол-во вакансий",
            "Неограниченно кол-во ивентов",
            "Неограниченный Ai-smartmatching",
            "Доступен весь Ai функционал",
            "Безлимит на создание диалогов"
          ]
        )
      ];
    }
  
    // ⚡ Быстрый доступ как словарь
    static byType = (() => {
      const dict = {};
      for (const plan of PremiumPlansFactory.allPlans()) {
        dict[plan.type] = plan;
      }
      return dict;
    })();
  }